class CollectionLoadMore extends HTMLElement {
  connectedCallback() {
    this.btn = this.querySelector('.collection__load-more__btn');
    if (!this.btn) return;

    this.loading = false;
    this._prefetch = null;

    this.btn.addEventListener('click', () => this._render());

    this._prefetchObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this._prefetchObserver.disconnect();
          this._startPrefetch();
        }
      },
      { rootMargin: '0px 0px 1200px 0px' }
    );
    this._prefetchObserver.observe(this);

    this._renderObserver = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) this._render(); },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this._renderObserver.observe(this);
  }

  disconnectedCallback() {
    this._prefetchObserver?.disconnect();
    this._renderObserver?.disconnect();
  }

  _buildFetchUrl() {
    const { nextPage, sectionId } = this.btn.dataset;
    return nextPage.includes('?')
      ? `${nextPage}&section_id=${sectionId}`
      : `${nextPage}?section_id=${sectionId}`;
  }

  _startPrefetch() {
    if (this._prefetch) return;
    this._prefetch = fetch(this._buildFetchUrl())
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.text();
      })
      .then((html) => new DOMParser().parseFromString(html, 'text/html'));
  }

  async _render() {
    if (this.loading) return;
    this.loading = true;
    this.btn.disabled = true;

    this._startPrefetch();

    let skeletonsAdded = false;
    const skeletonTimeout = setTimeout(() => {
      this._showSkeletons();
      skeletonsAdded = true;
    }, 150);

    try {
      const doc = await this._prefetch;
      clearTimeout(skeletonTimeout);
      if (skeletonsAdded) this._removeSkeletons();

      const newGrid = doc.getElementById('product-grid');
      if (!newGrid) return;

      const grid = document.getElementById('product-grid');
      newGrid.querySelectorAll('.collection__grid__item').forEach((item) => grid.appendChild(item));

      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger();
      }

      const newSelf = doc.getElementById('collection-load-more');
      if (newSelf) {
        this.outerHTML = newSelf.outerHTML;
      } else {
        this.remove();
      }
    } catch (err) {
      clearTimeout(skeletonTimeout);
      this._removeSkeletons();
      console.error('[collection-load-more] fetch failed:', err);
      this.loading = false;
      this.btn.disabled = false;
    }
  }

  _showSkeletons() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const cols = parseInt(grid.dataset.colsDesktop, 10) || 4;
    const existing = grid.querySelector('.collection__grid__item');
    const height = existing ? Math.round(existing.getBoundingClientRect().height) : 400;

    for (let i = 0; i < cols; i++) {
      const el = document.createElement('div');
      el.className = 'collection__grid__item collection__grid__item--skeleton';
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('--skeleton-height', `${height}px`);
      grid.appendChild(el);
    }
  }

  _removeSkeletons() {
    document.getElementById('product-grid')
      ?.querySelectorAll('.collection__grid__item--skeleton')
      .forEach((el) => el.remove());
  }
}

customElements.define('collection-load-more', CollectionLoadMore);
